import { Outlet } from 'react-router-dom';

const ProtectedRoute = () => <Outlet />;

export default ProtectedRoute;
